"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prefixEnvironment = void 0;
const environments_prefix_1 = require("../../constants/environments-prefix");
const is_defined_1 = require("../../validation/is-defined/is-defined");
/**
 * Get the prefix of the environment in the given url or current if not passed
 * @public
 *
 * @param hostname - An optional domain.
 *
 * @returns "qa." if url has qa, local or localhost in its parts. "stg." if url has stg in its parts otherwise empty because there is no environment
 *
 * @example
 * ```ts
 * const qaPrefix = prefixEnvironment("https://enroll.qa.pivothealth.com");
 * ```
 */
function prefixEnvironment(hostname = '') {
    var _a;
    const environmentKey = (_a = process.env['ENVIRONMENT']) !== null && _a !== void 0 ? _a : '';
    if (environmentKey in environments_prefix_1.EnvironmentPrefix &&
        (0, is_defined_1.isDefined)(environmentKey))
        return environments_prefix_1.EnvironmentPrefix[environmentKey];
    const href = hostname || window.location.hostname;
    const link = document.createElement('a');
    link.href = href;
    const parts = link.hostname.split('.').map((s) => s.toUpperCase());
    for (const key of parts) {
        if (key in environments_prefix_1.EnvironmentPrefix && (0, is_defined_1.isDefined)(key)) {
            return environments_prefix_1.EnvironmentPrefix[key];
        }
    }
    return '';
}
exports.prefixEnvironment = prefixEnvironment;
//# sourceMappingURL=prefix-environment.js.map